export default {
  GROUP: 1,
  PRIVATE: 2,
};



// WEBPACK FOOTER //
// ./src/variables/ski/school/lesson-type-enums.js